





















import { Component, Prop, Vue } from "vue-property-decorator";
import DialogBox from "@/components/dialog-box/DialogBox.vue";

@Component({
    components: { DialogBox }
})
export default class OutOfStockDialog extends Vue {
    @Prop({ default: false }) isDialogOpen: boolean;
    @Prop({ default: "Confirmer cette action" }) title: string;
    @Prop({ default: "" }) proposition: string;

    stockOut() {
        this.emitAndReset("stockOut");
    }

    continueOrder() {
        this.emitAndReset("continueOrder", this.proposition);
    }

    cancel() {
        this.emitAndReset("cancel");
    }

    private emitAndReset(eventName: string, payload?: string): void {
        this.$emit(eventName, payload);
    }
}
